import './QueryEmulatorInput.sass'

import * as React from 'react'

import { QueryEmulatorInputProps } from './'

const QueryEmulatorInput: React.SFC<QueryEmulatorInputProps> = ({ value, wrapperClass, placeholder, onChange, postfix, initialValue, max = 100000, ...rest }): JSX.Element => {
  const renderPostfix = postfix ? <div className='postfix'>{postfix}</div> : null
  const additionalWrapperClass = wrapperClass ? wrapperClass : ''
  
  const handleChange = (e: any) => {
    const regexp = /^\s*\d*\s*$/
    const isNumber = regexp.test(e.currentTarget.value)
    const isInRange = 0 < e.currentTarget.value && e.currentTarget.value < max
    const isEmptyString = e.currentTarget.value === ''
    
    if ((isNumber && isInRange) || isEmptyString) {
      onChange(e)
    }
  }

  return (
    <div className={`query-emulator-input-wrapper ${additionalWrapperClass}`}>
      <div className='query-emulator-input'>
        <input
          placeholder={placeholder}
          value={value || initialValue}
          onChange={handleChange}
          {...rest}
        />
      </div>
      {renderPostfix}
    </div>
  )
}

export default QueryEmulatorInput